import * as React from "react";
import { Button, Grid, Image, Label } from "semantic-ui-react";
import colaboradorIcon from "../img/colaborador.svg";

const LoginTipo = (props) => {
    const { onChange, tipoAtendimento } = props;
    return (
        <Grid columns={2} centered>
            <Grid.Row className="rowLoginTipo" centered>
                <Grid.Column className="colunaTipoLogin">
                    <Button
                        className={tipoAtendimento === 0 ? "loginTipoAtendimentoToggle" : "loginTipoAtendimento"}
                        onClick={() => onChange(0)}
                    >
                        <Image src={require("../img/paciente.png")} verticalAlign="middle" />
                        <Label>Paciente</Label>
                    </Button>
                </Grid.Column>
                <Grid.Column className="colunaTipoLogin">
                    <Button
                        className={tipoAtendimento === 1 ? "loginTipoAtendimentoToggle" : "loginTipoAtendimento"}
                        onClick={() => onChange(1)}
                    >
                        <Image src={require("../img/medico2.png")} verticalAlign="middle" />
                        <Label>Médico</Label>
                    </Button>
                </Grid.Column>
                <Grid.Column className="colunaTipoLogin colaborador">
                    <Button
                        className={tipoAtendimento === 9 ? "loginTipoAtendimentoToggle" : "loginTipoAtendimento"}
                        onClick={() => onChange(9)}
                    >
                        <Image src={colaboradorIcon} verticalAlign="middle" />
                        <Label>Secretária</Label>
                    </Button>
                </Grid.Column>
            </Grid.Row>
            {/* <Grid.Row className='gridcolumnTipoLogin' centered>
                <Grid.Column className='colunaTipoLogin' >
                    <Button className={tipoAtendimento === 3 ? 'loginTipoAtendimentoToggle' : 'loginTipoAtendimento'} onClick={() => onChange(3)}>
                        <Image src={require('../img/empresas.png')} verticalAlign='middle' />
                        <Label >Empresas</Label>
                    </Button>
                </Grid.Column>
                <Grid.Column  className='colunaTipoLogin'>
                    <Button className={tipoAtendimento === 2 ? 'loginTipoAtendimentoToggle' : 'loginTipoAtendimento'} onClick={() => onChange(2)}>
                        <Image src={require('../img/convenios.png')} verticalAlign='middle' />
                        <Label >Convenios</Label>
                    </Button>
                </Grid.Column>
            </Grid.Row> */}
        </Grid>
    );
};

export default LoginTipo;
